/**
 * konstansok a store adatok lejáratához
 * ennyi ideig lesznek validak az adatok
 *
 * @type {{
 *   HALF_MIN: Number,
 *   ONE_MIN: Number,
 *   TWO_MIN: Number,
 *   THREE_MIN: Number,
 * }}
 */
export default {
  HALF_MIN: 30,
  ONE_MIN: 60,
  TWO_MIN: 120,
  THREE_MIN: 180,
}
